import Vue from 'vue';
import initialState from './defaultState';

export default {
    resetStateMutation(state) {
        const defaultState = initialState();

        Object.keys(state).forEach(item => {
            Vue.set(state, item, defaultState[item]);
        })
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.logGridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.logGridIsOpen = false;
    },
    setLogOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.logGridIsOpen = true;
    }
}
